export default "__VITE_ASSET__Do26_9ws__"